import React, { useState } from "react";
import { Box, Button, DialogActions, DialogContent, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { AdjustedProductType } from "../../../interfaces/DTO/mislaka_xml_models";
import { HandlerAutocompleteField } from "../../../shared/Autocompletes/HandlerAutocompleteField";
import { formatProductTypeUniversal } from "../../../utils/productTypeUniversalFormatter";
import { buildNewFund } from "./quickActions";

// the savings products a new fund can be opened for
const NEW_FUND_PRODUCT_TYPES: number[] = [
  AdjustedProductType.PROVIDENT_FUND,
  AdjustedProductType.EDUCATION_FUND,
  AdjustedProductType.INVESTMENT_PROVIDENT_FUND,
  AdjustedProductType.PURE_SAVINGS_POLICY,
  AdjustedProductType.PENSION_FUND,
];

export interface NewFundContactOption {
  id: number;
  name: string;
}

interface Props {
  /** whose fund - one option (a basket is of one client), or the family members to choose from */
  contacts: NewFundContactOption[];
  reportedPeriod: string;
  onCreate: (fund: MimshakData) => void;
  onCancel: () => void;
}

/** קופה חדשה להפקדה / הוראת קבע: סוג מוצר, יצרן (ובתצוגת משפחה – של מי) */
const NewFundForm: React.FC<Props> = ({ contacts, reportedPeriod, onCreate, onCancel }) => {
  const [productType, setProductType] = useState<number | "">("");
  const [handlerCode, setHandlerCode] = useState("");
  const [contactId, setContactId] = useState<number | "">(contacts.length === 1 ? contacts[0].id : "");

  const canCreate = productType !== "" && !!handlerCode && contactId !== "";

  return (
    <>
      <DialogContent>
        <Typography variant="subtitle2" sx={{ mb: 2 }}>
          קופה חדשה
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {contacts.length > 1 && (
            <FormControl fullWidth>
              <InputLabel>של מי?</InputLabel>
              <Select value={contactId} label="של מי?" onChange={(e) => setContactId(e.target.value as number)}>
                {contacts.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl fullWidth>
            <InputLabel>סוג מוצר</InputLabel>
            <Select value={productType} label="סוג מוצר" onChange={(e) => setProductType(e.target.value as number)}>
              {NEW_FUND_PRODUCT_TYPES.map((t) => (
                <MenuItem key={t} value={t}>
                  {formatProductTypeUniversal(t)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <HandlerAutocompleteField value={handlerCode} onChange={setHandlerCode} placeholder="בחר יצרן..." />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" size="large">
          חזור
        </Button>
        <Button
          variant="contained"
          size="large"
          disabled={!canCreate}
          onClick={() => canCreate && onCreate(buildNewFund(contactId as number, reportedPeriod, handlerCode, productType as number))}
        >
          המשך
        </Button>
      </DialogActions>
    </>
  );
};

export default NewFundForm;
